// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .breadcrumb-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 18px;
  line-height: 18px;
  padding: 18px;
  background-color: #f5f5f5;
  border-bottom: 1px solid var(--color-line-subtle, #e6e6e6);
  background: var(--color-background-subtle, #fafafa);
} */

.breadcrumb-section {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  height: 18px;
  line-height: 18px;
  padding: 13px;
  padding-left: 40px;
  /* background-color: #f5f5f5; */
  /* border-bottom: 1px solid var(--color-line-subtle, #e6e6e6); */
  background: var(--color-background-subtle, #fafafa);

  /* Position it below the header */
  position: fixed;
  top: 54px; /* Same as your sidenav's top position */

  z-index: 99; /* Below sidenav but above content */
}
`, "",{"version":3,"sources":["webpack://./src/css/breadcrumb.css"],"names":[],"mappings":"AAAA;;;;;;;;;;GAUG;;AAEH;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,+BAA+B;EAC/B,gEAAgE;EAChE,mDAAmD;;EAEnD,iCAAiC;EACjC,eAAe;EACf,SAAS,EAAE,wCAAwC;;EAEnD,WAAW,EAAE,oCAAoC;AACnD","sourcesContent":["/* .breadcrumb-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 18px;\n  line-height: 18px;\n  padding: 18px;\n  background-color: #f5f5f5;\n  border-bottom: 1px solid var(--color-line-subtle, #e6e6e6);\n  background: var(--color-background-subtle, #fafafa);\n} */\n\n.breadcrumb-section {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n  height: 18px;\n  line-height: 18px;\n  padding: 13px;\n  padding-left: 40px;\n  /* background-color: #f5f5f5; */\n  /* border-bottom: 1px solid var(--color-line-subtle, #e6e6e6); */\n  background: var(--color-background-subtle, #fafafa);\n\n  /* Position it below the header */\n  position: fixed;\n  top: 54px; /* Same as your sidenav's top position */\n\n  z-index: 99; /* Below sidenav but above content */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
